module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"row\">\n	<p>Строк в файле: <span>")
    ; __append(escapeFn( data.count ))
    ; __append("</span></p>\n	<p>Пустых строк в файле: <span>")
    ; __append(escapeFn( data.empty ))
    ; __append("</span></p>\n\n	")
    ;  if (data.duplicate > 0) { 
    ; __append("\n		<p class=\"warning\">Строк для которых найдено несколько совпадений в БД: <span>")
    ; __append(escapeFn( data.duplicate ))
    ; __append("</span></p>\n	")
    ;  } 
    ; __append("\n</div>\n\n<div class=\"row\">\n	<p>Будет добавлено: <span>")
    ; __append(escapeFn( data.inserted ))
    ; __append("</span></p>\n\n	")
    ;  if (data.insertFailed > 0) { 
    ; __append("\n		<p class=\"warning\">Строк при добавлении которых возникли ошибки: <span>")
    ; __append(escapeFn( data.insertFailed ))
    ; __append("</span></p>\n	")
    ;  } 
    ; __append("\n\n	<p>Будет обновлено: <span>")
    ; __append(escapeFn( data.updated ))
    ; __append("</span></p>\n\n	")
    ;  if (data.updateFailed > 0) { 
    ; __append("\n		<p class=\"warning\">Строк при обновлении которых возникли ошибки: <span>")
    ; __append(escapeFn( data.updateFailed ))
    ; __append("</span></p>\n	")
    ;  } 
    ; __append("\n\n	<p>Будет пропущено: <span>")
    ; __append(escapeFn( data.skipped ))
    ; __append("</span></p>\n</div>\n\n<div class=\"row\">\n	<button on-click=\"onBackStepClick\" data-step=\"stepMapping\">Назад</button>\n	")
    ;  if ((data.inserted + data.updated) > 0) { 
    ; __append("\n		<button on-click=\"onImportClick\" class=\"gl-primary-button\">Импортировать данные</button>\n	")
    ;  } 
    ; __append("\n</div>")
  }
  return __output.join("");

}